import React from 'react'
import classNames from 'classnames'
import { H1, Paragraph, Card } from '@zooz/generic-ui-components'
import { Link } from 'react-router-dom'

import { externalLocations } from '../../../../helpers/tools/locations/externalLocations'
import { LanguageSelection } from '../../../Localize/components'
import Messages from '../../../Messages'
import logo from '../zooz-payu-logo.svg'

import css from './PageStructure.scss'

interface PageProps {
  id?: string,
  className?: string,
  title?: string,
  subtitle?: string,
  links?: {
    to?: string,
    id: string,
    text: string
  }[]

}

const Page: React.FC<PageProps> = ({
  id,
  className,
  title,
  subtitle,
  children,
  links
}) => (
  <>
    <Messages />
    <div id={id} className={classNames(css.page, className)}>
      <a className={css.logo} target='_blank' rel='noopener noreferrer' href={externalLocations.zoozWebsite}>
        <img src={logo} />
      </a>
      <div className={css.backgroundLogo} />
      <Card type={Card.CARD_TYPES.DEFAULT} className={css.content}>
        <div className={css.header}>
          <H1 type={H1.TYPES.PAGE_TITLE} className={css.title}>
            {title}
          </H1>
          {subtitle ? <Paragraph className={css.subtitle}>{subtitle}</Paragraph> : null}
        </div>
        <div className={css.form}>
          {children}
        </div>
        {
            links && links.length > 0
              ? (
                <div className={css.links}>
                  {links.map(link => (
                    <Link key={link.id} id={link.id} to={link.to}>
                      {link.text}
                    </Link>
                  ))}
                </div>
                )
              : null
            }
      </Card>
      <div className={css.languageSelector}>
        <LanguageSelection showNewLanguageTooltip />
      </div>
    </div>
  </>
)

export default Page
